import React from "react";
import "./Job_Address_card.css";

function Job_Address_card({order}) {
  return (
    <section className="Job_Address_card">
      <div className="card-header">Billing Address</div>
      <div className="card-body">
        <h3 className="card-title">{order?.name}</h3>
        <p className="card-text">
        {order?.company_name}, {order?.address_one}, {order?.address_two}, <br />
        {order?.Country?.name},  {order?.State?.name},  {order?.City?.name} {order?.Pincode?.name}
        </p>
        <p className="card-text">
        Mob: {order?.contact_no}
        </p>
      </div>
    </section>
  );
}

export default Job_Address_card;
